import { lazydocConfig } from './lazydoc/settings';
import { rumidimurConfig } from './rumidimur/settings';
import { budzdorovConfig } from './budzdorov/settings';
import { BrandConfig, BrandId, BrandsRegistry } from '../types/config.types';

/**
 * Реестр всех доступных брендов
 */
export const brandsRegistry: BrandsRegistry = {
    lazydoc: lazydocConfig,
    rumidimur: rumidimurConfig,
    budzdorov: budzdorovConfig,
};

/**
 * Получить конфиг бренда по ID
 * @param brandId - ID бренда
 * @returns Конфиг бренда
 */
export function getBrandConfig(brandId: BrandId): BrandConfig {
    const config = brandsRegistry[brandId];
    if (!config) {
        console.warn(`Brand "${brandId}" not found, using LazyDoc as fallback`);
        return lazydocConfig;
    }
    return config;
}

/**
 * Получить ID бренда из переменной окружения или URL параметра
 * @returns ID бренда
 */
export function detectBrandId(): BrandId {
    // 1. Проверяем hostname (имеет наивысший приоритет для production)
    const hostname = window.location.hostname;
    if (hostname.includes('rmdmr')) return 'rumidimur';
    if (hostname.includes('bzklinika.ru') || hostname.includes('c-clinica')) return 'budzdorov';
    if (hostname.includes('lazydoc.ai') || hostname.includes('lazydoc.su')) return 'lazydoc';

    // 2. Проверяем REACT_APP_BRAND переменную окружения (для локальной разработки)
    const envBrand = process.env.REACT_APP_BRAND as BrandId | undefined;
    if (envBrand && brandsRegistry[envBrand]) {
        return envBrand;
    }

    // 3. Проверяем URL параметр ? brand=
    const urlParams = new URLSearchParams(window.location.search);
    const urlBrand = urlParams.get('brand') as BrandId | null;
    if (urlBrand && brandsRegistry[urlBrand]) {
        return urlBrand;
    }

    // 4. По умолчанию возвращаем LazyDoc
    return 'budzdorov';
}

/**
 * Получить все доступные бренды
 * @returns Массив конфигов всех брендов
 */
export function getAllBrands(): BrandConfig[] {
    return Object.values(brandsRegistry);
}

/**
 * Проверить, доступен ли бренд
 * @param brandId - ID бренда
 * @returns true если бренд доступен
 */
export function isBrandAvailable(brandId: BrandId): boolean {
    return Boolean(brandsRegistry[brandId]);
}

// Экспортируем конфиги для прямого импорта
export { lazydocConfig, rumidimurConfig, budzdorovConfig };